import { emptyObject } from 'ui-components/default-props/empty';
import { noop } from 'ui-components/default-props/noop';

import CostReviewLineItemService from '../cost-review-line-item-service';
import { CostReviewLabelProviderInsuranceLineItemWithRecommendation } from './cost-review-label-provider-insurance-line-item-with-recommendation';

/**
 * @param {object} props
 * @param {CostReviewInsuranceRecommendation} [props.insuranceRecommendation]
 * @param {(recommendationKey: string) => void} [props.onToggleRecommendation]
 * @param {boolean} [props.isToggleRecommendationDisabled]
 * @param {boolean} [props.isRecommendationSelected]
 * @param {string} props.insuranceServiceName
 * @param {number} props.insuranceServiceCostAmount
 * @param {string} props.insuranceServiceCostCurrencyCode
 * @returns {React.JSX.Element}
 */
export const CostReviewLabelProviderInsuranceLineItem = ({
  insuranceRecommendation = emptyObject,
  onToggleRecommendation = noop,
  isToggleRecommendationDisabled = false,
  isRecommendationSelected = false,
  insuranceServiceName,
  insuranceServiceCostAmount,
  insuranceServiceCostCurrencyCode,
}) => {
  if (!insuranceRecommendation || !Object.keys(insuranceRecommendation).length) {
    return (
      <CostReviewLineItemService
        serviceCost={insuranceServiceCostAmount}
        serviceCurrencyCode={insuranceServiceCostCurrencyCode}
        serviceName={insuranceServiceName}
      />
    );
  }

  return (
    <CostReviewLabelProviderInsuranceLineItemWithRecommendation
      insuranceRecommendation={insuranceRecommendation}
      isRecommendationSelected={isRecommendationSelected}
      isToggleRecommendationDisabled={isToggleRecommendationDisabled}
      onToggleRecommendation={onToggleRecommendation}
      originalInsuranceCostAmount={insuranceServiceCostAmount}
      originalInsuranceCostCurrencyCode={insuranceServiceCostCurrencyCode}
      originalInsuranceName={insuranceServiceName}
    />
  );
};
